module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(dates, function(dateItem){
__p+='\r\n<div class="hotelSerpContainer__tabs-content-dates__date js-carousel-slide '+
((__t=( dateItem.date === selectedTabDate ? 'hotelSerpContainer__tabs-content-dates__date_active' : 'js-date-tab-choose' ))==null?'':__t)+
'"\r\n	 data-date="'+
((__t=( dateItem.date ))==null?'':__t)+
'">\r\n	<div class="hotelSerpContainer__tabs-content-dates__date-label">\r\n		'+
((__t=( dateItem.dateLabel ))==null?'':__t)+
',\r\n		<span>'+
((__t=(dateItem.dayStr))==null?'':__t)+
'</span>\r\n	</div>\r\n	';
 if(dateItem.price) { 
__p+='\r\n	<div class="hotelSerpContainer__tabs-content-dates__date-price-label">от '+
((__t=(
		dateItem.price.formatNumber() ))==null?'':__t)+
' руб.\r\n		';
 if(dateItem.itIsMinPrice){
__p+='\r\n		<div class="hotelSerpContainer__tabs-content-dates__min-price">Лучшая цена</div>\r\n		';
}
__p+='\r\n	</div>\r\n	';
 } else { 
__p+='\r\n	<div class="hotelSerpContainer__tabs-content-dates__noPrice-label">нет туров</div>\r\n	';
 } 
__p+='\r\n</div>\r\n';
})
__p+='';
}
return __p;
};
